import { app } from '../../../app';

app.factory('UsersSharedAccountService', UsersSharedAccountService);

/** @ngInject */
function UsersSharedAccountService($resource) {
    var rootUrl = 'app/rest/corporateServices';
    return {
		usersSharedNotes: $resource('app/rest/shared_notes',{},{
			'getUsersSharedNotes' :{
				method: 'GET',
				isArray:true
			}
		}),
        usersCompanySharedAccounts : $resource(rootUrl, {},{
			
			'getCompaniesToShareWith' :{
				method: 'GET',
				url: rootUrl+'/companies?canShare=true',
				isArray:true
			 },
			'shareAccountsWithCompany' :{
				method:'POST',
				url: rootUrl+'/companies/:companyId?showOtp=:showOtp&showPassword=:showPass',
				params:{
					companyId: '@companyId',
					showOtp: '@showOtp',
					showPass: '@showPass',
					
				}
			}
		}),
        userSharedAccountSSO : $resource(rootUrl + '/:id', {
            id : '@id'
        }, {
            'query' : {
                method : 'GET',
                isArray : true
            },
            'get' : {
                method : 'GET'
            },
            'getTracker' : {
                method : 'GET',
                url : 'app/rest/corporateServices/tracker/:id',
                isArray : false,
                params : {
                    id : '@id',
                },
                transformResponse : function(data, headers) {
                    return {
                        tracker : data,
                        shared : true
                    };
                }
            }
        }),
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.service.js